export default ({ variableKey }) => {
  const body = document.querySelector('body');
  if (!body) return;
  return getComputedStyle(body).getPropertyValue(variableKey).trim();
};
